import type { Plan } from '@/services/httpServices/websiteService'

/**
 * Health-checkup packages shown in the home page "Plans & Pricing" section.
 * Used as an offline fallback when the website API is unreachable so the
 * section never renders empty.
 */
export const plans: Plan[] = [
  {
    id: 'demo-plan-1',
    name: 'Basic Health Checkup',
    price: '৳1,500',
    description:
      'An affordable yearly checkup that screens the most common health risks for adults.',
    features: [
      'Complete Blood Count (CBC)',
      'Fasting blood sugar',
      'Blood pressure & BMI check',
      'Urine routine examination',
      'General physician consultation',
      'Report explanation & advice',
    ],
    popular: false,
    displayOrder: 1,
  },
  {
    id: 'demo-plan-2',
    name: 'Comprehensive Health Checkup',
    price: '৳3,500',
    description:
      'A complete body checkup with heart, liver, kidney and chest screening plus a specialist review.',
    features: [
      'Everything in the Basic package',
      'ECG (heart rhythm test)',
      'Liver & kidney function tests',
      'Lipid profile (cholesterol)',
      'Chest X-ray',
      'Specialist consultation',
      'One free follow-up visit',
    ],
    popular: true,
    displayOrder: 2,
  },
]
